import { useMemo } from 'react';

import useSiteMetadata from './use-site-metadata';

const URLS = {
  PRODUCT_URL: 'https://lucid.app',
};

const useProductUrls = (urlLangPrefix: string) => {
  const { siteName } = useSiteMetadata();
  const isProductUrl = siteName.match(/lucid(chart|scale|spark)/gi);
  const siteNameUrl = isProductUrl ? siteName.toLowerCase() : 'documents';

  const urls = useMemo(
    () => ({
      activateUrl: `${URLS.PRODUCT_URL}/${urlLangPrefix}users/login?activate=${siteName.toLowerCase()}`,
      newUserUrl: `${URLS.PRODUCT_URL}/${urlLangPrefix}users/level/newUser`,
      pricingUrl: `${URLS.PRODUCT_URL}/${urlLangPrefix}pricing/${siteName.toLowerCase()}`,
      productUrl: URLS.PRODUCT_URL,
      registerUrl: `${URLS.PRODUCT_URL}/${urlLangPrefix}${siteNameUrl}/editNewOrRegister`,
    }),
    [siteName, siteNameUrl, urlLangPrefix],
  );

  return urls;
};

export default useProductUrls;
